
.page {
  padding: 1rem;
}

.fw {
  width: 100%;
}

.trendingItem {
  width: 20rem;
  aspect-ratio: 1;
  background-color: var(--static-background-standard);
  border: 1px solid var(--static-divider-standard);
  border-radius: 10px;
}
